import '@salla.sa/twilight';

export function digitsOnly(num: string): string {
  return Salla.helpers.digitsOnly(num);
}

export function inputDigitsOnly(
  input: HTMLInputElement | string,
  is_decimal = false
): void {
  Salla.helpers.inputDigitsOnly(input, is_decimal);
}
